import React from 'react';
import { Box, Typography, TextField, Paper } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const BookingMessage = ({ value, onChange }) => {
  return (
    <Box sx={{ 
      p: 4, 
      borderRadius: '24px', 
      bgcolor: 'white', 
      border: '1px solid #F1F5F9' 
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Box sx={{ 
          width: 36, 
          height: 36, 
          borderRadius: '10px', 
          bgcolor: '#EFF6FF', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: '#0E2465'
        }}>
          <ChatBubbleOutlineIcon fontSize="small" />
        </Box>
        <Typography variant="h6" fontWeight="900" color="#0E2465">
          Mensaje o nota para el proveedor <Typography component="span" variant="inherit" color="#737791" sx={{ fontWeight: 500 }}>(Opcional)</Typography>
        </Typography>
      </Box>
      
      <Typography variant="body2" color="#737791" sx={{ mb: 3, fontWeight: 500, ml: 6.5 }}>
        Añade especificaciones, requerimientos especiales o contexto útil para tu servicio.
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder="Ej. Tengo intolerancia al gluten, requiero adaptar la sesión..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '16px',
            bgcolor: '#F8FAFC',
            '& fieldset': { borderColor: '#E2E8F0' },
            '&:hover fieldset': { borderColor: '#7495f8' },
            '&.Mui-focused fieldset': { borderColor: '#7495f8' }
          }
        }}
      />
    </Box>
  );
};

export default BookingMessage;
